module.exports = __webpack_public_path__ + "15e27e285ad4f74782b9aaa6f565a700.svg";